<template>
  <div
    class="accordion-item"
    :class="{ 'accordion-item--open': open }"
  >
    <div
      class="accordion-item__header"
      tabindex="0"
      @keydown.enter="toggle"
      @click="toggle"
    >
      <slot name="title">
        <p class="accordion-item__header--title">
          {{ title }}
        </p>
      </slot>
      <ChevronDown
        class="accordion-item__header--trigger"
        :class="{
          open,
        }"
      />
    </div>
    <Transition name="accordion">
      <div
        v-if="open"
        class="accordion-item__content"
      >
        <slot>
          <p
            class="accordion-item__content--text"
            v-html="content"
          ></p>
        </slot>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import ChevronDown from '@shared/assets/icon/ChevronDown.vue'

const open = ref(false)
const emit = defineEmits(['click'])

defineProps({
  title: {
    type: String,
    default: '',
  },
  content: {
    type: String,
    default: '',
  },
})

const toggle = () => {
  open.value = !open.value
  nextTick(() => {
    emit('click', open.value)
  })
}
</script>

<style lang="scss">
.accordion-item {
  border: 1px solid $kds-color-line-subtle;
  border-radius: $kds-shape-rounded-medium;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 0 $kds-space-2x;

  &--open {
    background-color: $kds-color-background-base;
  }

  &__header {
    @include flex-container(row, space-between);
    cursor: pointer;

    &--title {
      @include kds-typography-title-large;
      margin: $kds-space-2x 0;
    }
    &--trigger {
      @include margin(0);
      align-self: center;
      transition: transform 0.25s linear;

      &.open {
        transform: rotate(-180deg);
      }
    }
  }

  &__content {
    @include kds-typography-paragraph-large();
    overflow: hidden;
    padding-bottom: $kds-space-2x;
  }
}

.accordion-enter-active,
.accordion-leave-active {
  overflow: hidden;
  will-change: max-height, opacity;
}

.accordion-enter-active {
  max-height: 1000px;
  transition:
    max-height 0.24s ease,
    opacity 0.2s ease;
}

.accordion-leave-active {
  max-height: 1000px;
  transition:
    max-height 0.18s ease,
    opacity 0.15s ease;
}

.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
